"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dereferencer_1 = __importDefault(require("./dereferencer"));
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
exports.default = dereferencer_1.default(isomorphic_fetch_1.default, {
    access: function () { return Promise.resolve(false); },
    readFile: function () { return Promise.resolve(""); },
    constants: {
        F_OK: 0,
        R_OK: 4,
    },
});
